import script from "./PendingInvitationsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingInvitationsModal.vue?vue&type=script&setup=true&lang=js"

import "./PendingInvitationsModal.vue?vue&type=style&index=0&id=5c9591c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9591c8"]])

export default __exports__